const BROWSER_STORAGE_KEY = 'toi_subscription';

export default BROWSER_STORAGE_KEY;
